module.exports = __webpack_public_path__ + "img/must pay.c67481cf.svg";